import { SxProps } from '@mui/material';
import Grid from '@mui/material/Grid';
import React, { PropsWithChildren } from 'react';

type Props = {
  sx?: SxProps;
  width?: string;
  justifyContent?: string;
};

const WsGridContainer = (props: PropsWithChildren<Props>) => {
  return (
    <Grid
      container
      justifyContent={props.justifyContent !== undefined ? props.justifyContent : 'center'}
      sx={{ flexGrow: 1, ...(props.width && { width: props.width }), ...props.sx }}
    >
      {props.children}
    </Grid>
  );
};

export default WsGridContainer;
